module.exports = __webpack_public_path__ + "img/sc-4p-2023-3.86744e91.png";